(function($) {
  'use strict';

  const image_carousel = {
    dom: function() {
      this.$header = $('.image-carousel__header');
      this.$carousel = $('.image-carousel__slides');
      this.$nav = {
        'prev': $('.image-carousel__nav-item--prev'),
        'next': $('.image-carousel__nav-item--next')
      };
    },

    carousel: function() {
      let leftOffset = this.$header.offset().left;

      this.$carousel.each(function() {
        let $this = $(this);
        let items = 3;
        let padding = leftOffset;
        let slideAnim = $this.attr('data-carousel-fade') ? $this.data('carousel-fade') : true;
        let loop = false;

        let $carousel = $this.addClass('owl-carousel owl-theme').owlCarousel({
          dots: false,
          nav: false,
          loop: loop,
          mouseDrag: false,
          smartSpeed: 1000,
          stagePadding: padding ? padding : 0,
          responsive: {
            0: {
              dots: true,
              nav: false,
              items: items / 3 > 1 ? Math.floor(items / 3) : 1,
              margin: 16,
            },
            621: {
              dots: true,
              nav: false,
              items: Math.floor(items / 2),
              margin: 24,
            },
            809: {
              items: items,
              margin: 32,
            },
            981: {
              items: items,
              margin: 32,
            },
            1361: {
              margin: 48
            }
          },
          onInitialized: function(event) {
            let index = event.item.index;
            let last = Math.floor(event.page.size);
            let $next = $('.owl-item', $this).eq(index + last);
            let $nextImage = $next.find('.lazyload');

            if (slideAnim) {
              $('.owl-item', $this).eq(index + last).addClass('sliding');
            }

            if ($nextImage.length && $nextImage.attr('data-src')) {
              let src = $nextImage.attr('data-src');
              $nextImage.attr('src', src).removeAttr('data-src');
            }
          },
          onTranslate: function(event) {
            let index = event.item.index;
            let last = Math.floor(event.page.size);
            let $prev = $('.owl-item', $this).eq(index - 1);
            let $prevImage = $prev.find('.lazyload');
            let $next = $('.owl-item', $this).eq(index + last);
            let $nextImage = $next.find('.lazyload');

            if (slideAnim) {
              $('.owl-item', $this).eq(index + last - 1).removeClass('sliding');
              $next.addClass('sliding');
              $('.owl-item', $this).eq(index - 1).addClass('sliding');
            }

            if ($prevImage.length && $prevImage.attr('data-src')) {
              let prevSrc = $prevImage.attr('data-src');
              $prevImage.attr('src', prevSrc).removeAttr('data-src');
            }

            if ($nextImage.length && $nextImage.attr('data-src')) {
              let nextSrc = $nextImage.attr('data-src');
              $nextImage.attr('src', nextSrc).removeAttr('data-src');
            }
          },
          onTranslated: function(event) {
            let index = event.item.index;
            let last = Math.floor(event.page.size);
            let $next = $('.owl-item', $this).eq(index + last);
            let $nextImage = $next.find('.lazyload');

            if (slideAnim) {
              $('.owl-item', $this).removeClass('sliding');
              $next.addClass('sliding');
            }

            if ($nextImage.length && $nextImage.attr('data-src')) {
              let src = $nextImage.attr('data-src');
              $nextImage.attr('src', src).removeAttr('data-src');
            }
          },
          onResize: function(event) {
            leftOffset = image_carousel.$header.offset().left;
            $carousel.data('owl.carousel').options.stagePadding = leftOffset;
          }
        });

        image_carousel.nav($carousel);
      });
    },

    nav: function($carousel) {
      this.$nav.prev.on('click', function() {
        $carousel.trigger('prev.owl.carousel');
      });

      this.$nav.next.on('click', function() {
        $carousel.trigger('next.owl.carousel');
      });
    },

    ready: function() {
      this.dom();
      this.carousel();
    }
  };

  $(function() {
    if ($('.image-carousel__slides').length) {
      image_carousel.ready();
    }
  });

})(jQuery);
